;(function (window, document, undefined) {

    // IE10
    Modernizr.addTest('ie10', function () {
        // http://stackoverflow.com/questions/9900311/how-do-i-target-only-internet-explorer-10-for-certain-situations-like-internet-e
        'use strict';
        return (/*@cc_on!@*/false && document.documentMode === 10);
    });


    // IE11
    Modernizr.addTest('ie11', function () {
        // https://en.wikipedia.org/wiki/Internet_Explorer_11
        'use strict';
        // var ua = navigator.userAgent;
        // var match = /Trident.*rv[\s:]11\./i.test(ua);
        // ('msTransform' in document.body.style)
        var match = (
            !!document.documentMode &&
            !document.all &&
            (!!window.matchMedia || !!window.msMatchMedia) &&
            !Modernizr.websqldatabase &&
            !Modernizr.cssreflections
        );
        return match && (window.navigator.userAgent.indexOf('Edge/') == -1);
    });
    
    Modernizr.addTest('ie', function () {
        var ua = navigator.userAgent;
        return navigator.appName === 'Microsoft Internet Explorer' || !!(ua.match(/Trident/) || ua.match(/rv:11/))
    });
    
    Modernizr.addTest('safari', function () {
        return /.+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent);
    });
    
})(window, document);
